import React from "react";
import { Container, Grid, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TeacherCheckInCard } from "../../components/teacher-attendance/TeacherCheckInCard";
import { TeacherAttendanceCalendar } from "../../components/teacher-attendance/TeacherAttendanceCalendar";

const TeacherAttendancePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="xl" sx={{ mt: 3, mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom color="primary">
          {t("my_attendance_dashboard", "My Attendance Dashboard")}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t("attendance_subtitle", "Manage your daily check-in / check-out operations and review historical logs.")}
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {/* Left column: Daily Widget */}
        <Grid item xs={12} lg={4}>
          <Box sx={{ position: { lg: "sticky" }, top: "24px" }}>
            <TeacherCheckInCard />
          </Box>
        </Grid>

        {/* Right column: Monthly History */}
        <Grid item xs={12} lg={8}>
          <TeacherAttendanceCalendar />
        </Grid>
      </Grid>
    </Container>
  );
};

export default TeacherAttendancePage;
